// e.g. src/config.js
// const API_BASE = "https://robio-server.onrender.com";
// const API_BASE = "http://127.0.0.1:5000";
const API_BASE_DISCOVER = "https://biopathsim-api.anu-priya-jayaraj08.workers.dev";

export default API_BASE_DISCOVER;
